import { DatabaseCode, toDatabaseCode } from "./database-code";

export type FileType = DatabaseCode & {
  extensions: string[];
};

const pdf: FileType = {
  code: "PDF",
  displayValue: {
    id: "common.entity.filetype.pdf",
    defaultMessage: "PDF",
  },
  extensions: ["pdf"],
};

const excel: FileType = {
  code: "EXCEL",
  displayValue: {
    id: "common.entity.filetype.excel",
    defaultMessage: "Excel",
  },
  extensions: ["xlsx", "xls"],
};

const csv: FileType = {
  code: "CSV",
  displayValue: {
    id: "common.entity.filetype.csv",
    defaultMessage: "CSV",
  },
  extensions: ["csv"],
};

const html: FileType = {
  code: "HTML",
  displayValue: {
    id: "common.entity.filetype.html",
    defaultMessage: "HTML",
  },
  extensions: ["html", "htm"],
};

const json: FileType = {
  code: "JSON",
  displayValue: {
    id: "common.entity.filetype.json",
    defaultMessage: "JSON",
  },
  extensions: ["json"],
};

const txt: FileType = {
  code: "TXT",
  displayValue: {
    id: "common.entity.filetype.txt",
    defaultMessage: "Text",
  },
  extensions: ["txt", "log"],
};

const zip: FileType = {
  code: "ZIP",
  displayValue: {
    id: "common.entity.filetype.zip",
    defaultMessage: "ZIP",
  },
  extensions: ["zip"],
};

const image: FileType = {
  code: "IMAGE",
  displayValue: {
    id: "common.entity.filetype.image",
    defaultMessage: "Image",
  },
  extensions: [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "webp",
    "tif",
    "tiff",
    "bmp",
    "svg",
    "heic",
    "heif",
  ],
};

const video: FileType = {
  code: "VIDEO",
  displayValue: {
    id: "common.entity.filetype.video",
    defaultMessage: "Video",
  },
  extensions: [
    "mp4",
    "mov",
    "avi",
    "mkv",
    "webm",
    "flv",
    "wmv",
  ],
};

const unknown: FileType = {
  code: "UNKNOWN",
  displayValue: {
    id: "common.entity.filetype.unknown",
    defaultMessage: "Unknown",
  },
  extensions: [],
};

export const fileType = {
  pdf,
  excel,
  csv,
  html,
  json,
  txt,
  zip,
  image,
  video,
  unknown,
};

export const fileTypes = Object.values(fileType);

export const toFileType = (code: string): FileType =>
  toDatabaseCode(code, fileTypes);

export const toFileTypeSafely = (
  code: string | undefined
): FileType | undefined =>
  code ? toDatabaseCode(code, fileTypes) : undefined;
